import { SDK_INIT_ERROR_NAME } from '../const'

const handleInitError = (widgetHelpers, logger) => {
  const { initWidgetError } = widgetHelpers || {}

  if (initWidgetError && logger) {
    logger.error(SDK_INIT_ERROR_NAME, widgetHelpers, 'Error while initializing the widget')
  }
}

export default handleInitError
